import React from "react";
import ReactDOM from "react-dom/client"; // Ensure you're using React 18+ syntax
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root")); // Ensure the 'root' element exists in index.html
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
